import { useContext } from "react";
import {
    AppBar,
    Container,
    Toolbar,
} from "@mui/material";
import { Link } from "react-router-dom";
import lightLogo from '../../Images/fouchain-logo-light.svg';
import darkLogo from "../../Images/fouchain-logo-dark.svg";
import { ThemeContext } from "../DarkMode/ThemeProvider";


const LoginHeader = () => {
    const { isLightMode, handleDarkmode } = useContext(ThemeContext);


    return (
        <div className="sidebar-main auth-header">

            <AppBar
                position="fixed"
                sx={{ boxShadow: "none", backgroundColor: "var(--color-BasicBg)" }}
            >
                <Container maxWidth="xl">
                    <Toolbar
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "0px 20px !important",
                            background: "none",
                        }}
                    >
                        <div>
                            <Link to={'/'}>
                                <div className="logo">
                                    <img width={120} src={!isLightMode ? lightLogo : darkLogo} alt="logo" />
                                </div>
                            </Link>
                        </div>
                    </Toolbar>
                </Container>
            </AppBar>
        </div>
    );
};

export default LoginHeader;
